export interface SubBrand {
  id: number;
  name: string;
  description: string | null;
  parentBrandId: number | null;
  defaultPriceListId: number | null;
  defaultNgLimit: number | null;
}

/** POST/PUT body for a sub-brand (no id — id is path/assigned). */
export type SubBrandPayload = Omit<SubBrand, 'id'>;

/** A row in the global DOMAINS table (domain → default brand / sub-brand). */
export interface Domain {
  domain: string;
  mx: string | null;
  defaultBrand: number | null;
  defaultSubBrand: number | null;
}

/** PUT /domains/{domain} body — domain itself is the path key. */
export type DomainUpdate = Pick<Domain, 'mx' | 'defaultBrand' | 'defaultSubBrand'>;

/** A row in MANDANT_DOMAIN (an allowed domain for one brand). */
export interface BrandDomain {
  domain: string;
  mailDomain: boolean;
}

/** Canonical form the backend stores: trimmed + lowercased. */
export function normalizeDomain(input: string): string {
  return input.trim().toLowerCase();
}

/**
 * Mirror of the backend bare-host rule: no scheme, path, port, or whitespace.
 * The backend is authoritative; this is for immediate client feedback only.
 */
export function isBareHost(input: string): boolean {
  const v = normalizeDomain(input);
  if (v.length === 0) return false;
  return !/[\s/:]/.test(v) && !v.includes('//');
}
